var _effectorFileName = "/builds/gmini/front-ui-kit/src/utils/usePrevious.ts";
import React from 'react';
/**
 * Хук для получения предыдущего состояния
 * @param value
 */

export function usePrevious(value) {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}